/**
 * @file 教程页页面顶部tab菜单
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback, useMemo} from 'react';
import {Menu} from 'antd';
import {MenuProps} from 'antd/es/menu';

import {ITutorialsGroupItem} from '../../type';

export interface ITopMenuProps {
    selectedKey: string;
    menuList: ITutorialsGroupItem[];
    onSelect: (param: string) => void;
    getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
}

const GroupMenu: React.FC<ITopMenuProps> = props => {
    const {
        selectedKey,
        menuList,
        onSelect,
        getPopupContainer
    } = props;

    const handleOnSelect = useCallback<Exclude<MenuProps['onSelect'], undefined>>(
        ({selectedKeys = []}) => {
            const key = selectedKeys[selectedKeys.length - 1] || '';
            onSelect('' + key);
        },
        [onSelect]
    );

    const selectedKeys = useMemo(() => {
        return [selectedKey];
    }, [selectedKey]);

    return (
        <Menu
            mode="horizontal"
            className="paddle-tutorials-group-menu"
            selectedKeys={selectedKeys}
            onSelect={handleOnSelect}
            getPopupContainer={getPopupContainer}
        >
            {menuList.map(menuItem => (
                <Menu.Item key={menuItem.id}>
                    {menuItem.title}
                </Menu.Item>
            ))}
        </Menu>
    );
};

export default GroupMenu;
